export default {
  'profile.verified': '認証済み',
  'profile.unverified': '未認証',
  'profile.refresh': '更新',
  'profile.name': '名前',
  'profile.getCode': '認証コードを取得',
  'profile.codeTip': '認証コードを入力してください',
  'profile.verifyCode': '認証コード',
  'profile.phoneChange': '電話番号を変更',
  'profile.checkPhone': '現在の電話番号を確認',
  'profile.bindNewPhone': '新しい携帯電話を紐付け',
  'profile.nuxt': '次へ',
  'profile.changeSuccess': '変更が完了しました！',
  'profile.firstNameTip': '名を入力してください',
  'profile.lastNameTip': '姓を入力してください',
  'profile.emailChange': 'メールアドレスを変更',
  'profile.checkEmail': '現在のメールアドレスを確認',
  'profile.bindNewEmail': '新しいメールアドレスを紐付け',
  'profile.bindEmailTip': '新しいメールアドレスを入力してください',
  'app.profile': 'プロフィール',
  'app.profile.account': 'アカウント情報',
  'app.profile.account.save': '保存する',
  'app.profile.account.account': 'アカウント',
  'app.profile.account.password': 'パスワード',
  'app.profile.account.password.update': '最終更新日時',
  'app.profile.account.password.reset': 'パスワードをリセット',
  'app.profile.account.name.first': '名',
  'app.profile.account.name.last': '姓',
  'app.profile.account.name.phone': '携帯電話番号',
  'app.profile.account.name.phone.tip':
    '認証コード・請求書・業務通知等の送信に、この電話番号を利用する可能性がございます。',
  'app.profile.account.name.url': 'コールバックURL',
  'app.profile.account.name.urlTip':
    'http:// または https:// で始まる必要があります（カスタムポート非対応）。10.0.0.0/8、172.16.0.0/12、192.168.0.0/16のプライベートIPアドレスは使用できません。',
  'app.profile.account.name.verification': '認証状態',
  'app.profile.account.name.verification.tip[1]': '認証済み',
  'app.profile.account.name.verification.tip[2]': '認証失敗',
  'app.profile.developer': '開発者情報',
  'app.profile.developer.remark': 'API呼び出し時のみ利用可能',
  'app.profile.developer.label[1]': '開発者ID（DevKey）',
  'app.profile.developer.label[2]': 'API DevSecret',
  'app.profile.developer.copy': '表示およびコピー',
  'app.profile.developer.reset': 'リセット',
  'app.profile.developer.reset.tip': '注意',
  'app.profile.developer.reset.tip.content':
    'Dev Secretの変更はAPIプッシュに影響し、呼び出しコードの修正が必要です。',
  'app.profile.developer.reset.tip.sure': '確認',
  'app.profile.developer.reset.tip.cancel': '後で',
  'app.profile.developer.copy.success': 'コピーに成功しました',
  'app.profile.developer.reset.success': 'リセットに成功しました',
  'app.profile.single': 'シングルサインオン',
  'app.profile.single.tip[1]': 'セキュリティを向上させ、アカウントのリスクを低減',
  'app.profile.single.tip[2]': '従業員が異なる業務システムを使用する際のアカウントの重複作成を防止',
  'app.profile.single.tip[3]': '内部従業員アカウントシステムを使用して認証を簡素化',
  'app.profile.single.enable': 'お問い合わせ',
  'app.profile.single.title': '業務リクエスト',
  'app.profile.single.subject': 'タイトル',
  'app.profile.single.subject.value': 'アカウントのシングルサインオンを有効化',
  'app.profile.single.content':
    'こんにちは、シングルサインオンを有効化したいのですが、ご支援いただけますでしょうか。よろしくお願いします。',
  'app.profile.single.subject.validator': 'タイトルを入力してください',
  'app.profile.single.subject.doc': 'アカウントのシングルサインオンを有効化',
  'app.profile.single.message': 'メッセージ',
  'app.profile.single.message.validator': 'メッセージを入力してください',
  'app.profile.single.submit': '送信する',
  'app.profile.single.submit.success': `正常に送信されました。管理者からの返信をお待ちください。`,
  'app.profile.account.deletion': 'アカウントを削除',
  'app.profile.account.deletion.warn':
    'アカウントを削除すると、ユーザー情報、ビジネス情報、注文情報など関連データが完全に削除されます。一度削除すると、復元できません。',
  'app.profile.account.deletion.action': 'アカウントを削除',
  'app.profile.delete.title': 'アカウントを削除',
  'app.profile.delete.content':
    '警告！削除操作は取り消せません。このアカウントのユーザー・業務・残高・請求書・注文などの全データが永久削除され、関連サービスは終了します。',
  'app.profile.delete.content2':
    '「アカウントのメールアドレスを変更する」または「組織メンバーに役割権限を付与する」ことで目的を達成できる場合があります。必要でない限り、アカウントの継続利用を推奨いたします。',
  'app.profile.delete.warn': '未払い金がある場合、アカウントは削除できません！',
  'app.profile.delete.cancel': 'キャンセル',
  'app.profile.delete.next': '次へ',
  'app.profile.delete.delete': '削除',
  'app.profile.delete.confirm': '削除を確認',
  'app.profile.delete.confirm.content':
    'アカウント削除申請の最終処理前に、以下の認証手続きを行い、アカウントの安全性を確認させていただきます。メールに送信された認証コードをご確認ください。',
  'app.profile.delete.confirm.send': '認証コードを送信',
  'app.profile.delete.confirm.send.resend': '認証コードを再送信',
  'app.profile.delete.confirm.resend': '再送信する',
  'app.profile.delete.confirm.rule': '正しい認証コードを入力してください',
  'app.profile.delete.confirm.code.title': 'メール認証コード',
  'app.profile.delete.confirm.code.desc':
    '本人確認とアカウントの安全性を確保するため、メールに送信された認証コードを入力してください',
  'app.profile.delete.confirm.reason.title': '削除理由',
  'app.profile.delete.confirm.reason.desc': '製品改善の参考にさせていただきます',
  'app.profile.delete.confirm.reason.placeholder': '理由を選択',
  'app.profile.delete.confirm.reason.select1': 'テストアカウントを削除',
  'app.profile.delete.confirm.reason.select2': '別アカウントに切り替える',
  'app.profile.delete.confirm.reason.select3': 'EngageLabサービスの利用を終了',
  'app.profile.delete.confirm.reason.select4': 'その他',
  'app.profile.reset.title': 'パスワードをリセット',
  'app.profile.reset.password.old': '現在のパスワード',
  'app.profile.reset.password.old.placeholder': '現在のパスワードを入力してください',
  'app.profile.reset.password.new': '新しいパスワード',
  'app.profile.reset.password.new.placeholder': '新しいパスワードを入力してください',
  'app.profile.reset.password.confirm': 'パスワードを確認',
  'app.profile.reset.password.confirm.placeholder': 'パスワードを確認してください',
  'app.profile.reset.cancel': 'キャンセル',
  'app.profile.reset.confirm': '確認',
  'app.profile.rule.blank': 'この項目は必須です。',
  'app.profile.reset.new.rule[0]': '8文字以上で入力してください',
  'app.profile.reset.new.rule[1]': ' 大文字と小文字の両方を使用する必要があります',
  'app.profile.reset.new.rule[2]': '少なくとも1つの数字と記号を含めます',
  'app.profile.reset.confrim.rule[0]': 'パスワードが一致しません',
  'app.profile.reset.old.rule[0]': 'パスワードが不正です',
  'app.profile.reset.success': 'パスワードが更新されました',
  'app.profile.aws.title': 'Amazon 注文',
  'app.profile.aws.subtitle':
    'EngageLabアカウントはAmazonアカウントと連携済みです。こちらでAmazonの注文と対応するEngageLabサービスを紐付けることで、EngageLabのVIP特典を受け取ることができます。',
  'app.profile.aws.account': 'AmazonアカウントID：',
  'app.profile.aws.btn': '注文管理',
  'app.profile.human.code.loadingTip': 'しばらくお待ちください…',
  'app.profile.human.code.placeholder': '認証コードを入力してください',
  'app.profile.human.check.tip': 'まず、人間認証を完了してください。',
  'app.profile.human.check.error': '人間認証に失敗しました。もう一度お試しください。',
  'app.profile.sso.title': 'SSO設定サービス',
  'app.profile.sso.empty.title': 'SSOが設定されていません',
  'app.profile.sso.empty.description':
    'SSOを設定すると、設定された組織のユーザー、メンバー、ビジネスパートナーは、最適な仕事に必要なすべてのものに安全にアクセスでき、直感的なログイン体験を得ることができます。',
  'app.profile.sso.empty.configure': 'SSOを設定',
  'app.profile.sso.empty.title2': 'SSO特典がありません',
  'app.profile.sso.empty.description2':
    '組織はまだSSO特典を開放していません。特典を開放する前に、ビジネスに連絡してください。',
  'app.profile.sso.empty.contact': '連絡',
  'app.profile.sso.empty.contact.content': 'SSOを作成したい',
  'app.profile.sso.list.configure': 'SSOを設定',
  'app.profile.sso.list.authorizedOrg': '認証済み組織',
  'app.profile.sso.list.benefitStatus': '特典ステータス',
  'app.profile.sso.list.authorizedOrgLong':
    '認証済み組織認証済み組織認証済み組織認証済み組織認証済み組織認証済み組織認証済み組織',
  'app.profile.sso.list.edit': '編集',
  'app.profile.sso.list.authorize': '認証',
  'app.profile.sso.list.delete': '削除',
  'app.profile.sso.list.deleteConfirm.title': 'SSOサービス {name} の削除を確認しますか？',
  'app.profile.sso.list.deleteConfirm.content':
    'SSOサービスを削除すると、このサービスで認証された組織はSSOログインをサポートしなくなり、ログインリンクは無効になり、SSOログインの停止を求めるメールが送信されます。',
  'app.profile.sso.list.deleteSuccess': '削除が完了しました',
  'app.profile.sso.list.confirm.modify.title': 'SSOサービス認証を変更しますか？',
  'app.profile.sso.list.confirm.modify.content.add':
    '新たに認証された組織は、ログインリンクを含むメールを受け取ります。',
  'app.profile.sso.list.confirm.modify.content.remove':
    '認証された組織は、ログインリンクを含むメールを受け取ります。',
  'app.profile.sso.option.step1': 'IdP設定',
  'app.profile.sso.option.step2': 'データソース返却',
  'app.profile.sso.option.step3': '組織認証',
  'app.profile.sso.option.step4': '検証',
  'app.profile.sso.option.continue': '続行',
  'app.profile.sso.option.prev': '前へ',
  'app.profile.sso.option.back': '戻る',
  'app.profile.sso.option.submit': '送信',
  'app.profile.sso.option.save': '保存して検証',
  'app.profile.sso.step1.title': 'IdPでEngagelabを設定',
  'app.profile.sso.step1.description':
    'シングルサインオン（SSO）では、まずEngagelabをアイデンティティプロバイダー（IdP）のアプリケーションとして追加する必要があります。組織のIdP管理者に連絡して、アカウントの下にアプリケーション設定を追加してください。',
  'app.profile.sso.step1.serviceType': 'SSOサービスタイプ',
  'app.profile.sso.step1.guideText':
    '組織のIdP管理者と協力するために以下のトークンを使用できます：',
  'app.profile.sso.step1.copy': 'コピー',
  'app.profile.sso.step1.confirmTip':
    'Engagelabアプリケーションの情報がIdPで更新されたことを確認します',
  'app.profile.sso.step1.infoText': `I am setting up SSO for Engagelab, and I need assistance setting up Engagelab as an application in our identity provider.

Here is the information that Engagelab provides for setting up the application:

Entity ID:643e77b90116033eef7e325b001
ACS URL: https://www.engagelab.com/accounts/signin/callback?connection=643e77b90116033eef7e325b001
Login URL：https://www.engagelab.com/accounts/signin-sso
Logout URL：https://www.engagelab.com/api/console/account/login/out

Once the Engagelab application is set up in our IdP, please send me the following information from the IdP to complete SSO setup in Engagelab:

X.509 certificate:`,
  'app.profile.sso.step2.title': 'IdP返却データを入力',
  'app.profile.sso.step2.description':
    'アイデンティティプロバイダーでEngagelabアプリケーションを設定し、必要な情報を取得しました。IdPアプリケーションの以下の情報をここに入力してください。',
  'app.profile.sso.step2.serviceName': 'SSOサービス名',
  'app.profile.sso.step2.serviceNamePlaceholder':
    'サービスリストで区別しやすいSSOサービスを説明する名前を入力してください',
  'app.profile.sso.step2.certificate': 'x509証明書',
  'app.profile.sso.step2.certificatePlaceholder': 'base64証明書の内容をここにコピーしてください',
  'app.profile.sso.step2.loginUrl': 'IdPログインURL',
  'app.profile.sso.step2.loginUrlPlaceholder':
    'アイデンティティプロバイダーのログインURLを入力してください',
  'app.profile.sso.step2.logoutUrl': 'IdPログアウトURL',
  'app.profile.sso.step2.logoutUrlPlaceholder':
    'アイデンティティプロバイダーのログアウトURLを入力してください',
  'app.profile.sso.step3.title': 'IdPを組織に認証',
  'app.profile.sso.step3.description':
    'このSSOサービスを作成した組織に認証してください。組織メンバーは設定されたアイデンティティプロバイダー（IdP）を使用してEngagelabにログインできます。',
  'app.profile.sso.step3.selectOrg': '組織を選択',
  'app.profile.sso.step3.contactBusiness': 'ビジネスに連絡',
  'app.profile.sso.step3.noBenefitTip': '現在の組織には特典がなく、利用できません',
  'app.profile.sso.step3.saveConfirm.title':
    '組織にSSOサービスを設定すると、組織メンバーは組織にアクセスするためにSSOログインを使用する必要があります',
  'app.profile.sso.step3.saveConfirm.content':
    '保存後、すべての組織メンバーはログアウトされ、SSOログインを要求するメールが送信されます',
  'app.profile.sso.step3.canAuthorize': '許可可能',
  'app.profile.sso.step3.numLimit.title': '制限付き',
  'app.profile.sso.step3.numLimit.tip': 'SSOプロトコル数制限超過',
  'app.profile.sso.step3.numLimit.text': 'SSOプロトコル数制限超過、利用不可',
  'app.profile.sso.step3.noBenefit.title': '権利なし',
  'app.profile.sso.step3.noBenefit.text': '現在の組織には特典がなく、利用できません',
  'app.profile.sso.step3.column.orgId': '組織ID',
  'app.profile.sso.step3.column.orgName': '組織名',
  'app.profile.sso.step3.column.memberNum': 'メンバー数',
  'app.profile.sso.step3.column.authStatus': '認証ステータス',
  'app.profile.sso.step3.column.timeZone': 'タイムゾーン',
  'app.profile.sso.step3.column.createTime': '作成時間',
  'app.profile.sso.step4.title': 'SSOサービスを検証',
  'app.profile.sso.step4.description':
    'SSOのすべての設定が完了しました。最後に、ユーザーがSSOを使用してEngagelabに正常にログインできることを確認してください。',
  'app.profile.sso.step4.loginUrl': 'SSOログインURL',
  'app.profile.sso.step4.tip': 'ヒント',
  'app.profile.sso.step4.tipContent':
    'このリンクでログインするアカウントは、組織内に役割がない場合、自動的にDefault役割が付与されます。メンバーが参加した後、役割を変更できます。',
  'app.profile.sso.step4.notice': 'ご注意',
  'app.profile.sso.step4.noticeContent':
    'このリンクでログインするアカウントは、組織内に役割がない場合、自動的にDefault役割が付与されます。メンバーが参加した後、役割を変更できます。',
  'app.profile.sso.step4.needHelp': 'まだヘルプが必要ですか',
  'app.profile.sso.step4.helpContent':
    '正常にログインできませんか？ドキュメントを参照して検査してください。',
  'app.profile.sso.step4.viewDoc': 'ドキュメントを表示',
  'app.profile.sso.details.title': 'SSOサービス詳細',
  'app.profile.sso.details.serviceDetails': 'SSOサービス詳細',
  'app.profile.sso.details.name': '名前',
  'app.profile.sso.details.namePlaceholder': '名前を入力してください',
  'app.profile.sso.details.type': 'タイプ',
  'app.profile.sso.details.typePlaceholder': 'タイプを入力してください',
  'app.profile.sso.details.loginLink': 'SSOログインリンク',
  'app.profile.sso.details.loginLinkPlaceholder': 'SSOログインリンクを入力してください',
  'app.profile.sso.details.spConfig': 'SP設定情報',
  'app.profile.sso.details.entityIdPlaceholder': 'Entity IDを入力してください',
  'app.profile.sso.details.idpConfig': 'IDP設定情報',
  'app.profile.sso.details.certificatePlaceholder': 'X.509証明書を入力してください',
  'app.profile.sso.details.loginUrlPlaceholder': 'Login URLを入力してください',
  'app.profile.sso.details.logoutUrlPlaceholder': 'Logout URLを入力してください',
  'app.profile.sso.details.urlPlaceholder': '正しいURLを入力してください',
  'app.profile.sso.details.certificateExpiry': '証明書は{date}に期限切れになります',
  'app.profile.sso.details.cancel': 'キャンセル',
  'app.profile.sso.details.save': '保存',
  'app.profile.sso.details.edit': '編集',
  'app.profile.sso.orgSelect.title': '組織を認証',
  'app.profile.sso.orgSelect.availableOrg': '利用可能な組織',
  'app.profile.sso.orgSelect.serviceExpired': 'サービス特典が期限切れで利用できません',
  'app.profile.sso.orgSelect.contactBusiness': 'ビジネスに連絡',
  'app.profile.sso.orgSelect.authorizedService': '認証済みサービス',
  'app.profile.sso.orgSelect.serviceNameLong':
    'SSOサービス名サービス名サービス名サービス名SSOサービス名サービス名サービス名サービス名SSOサービス名サービス名サービス名サービス名SSOサービス名サービス名サービス名サービス名',
  'app.profile.sso.orgSelect.selectedOrg': '選択された組織',
  'app.profile.sso.orgSelect.noSelectedOrg': '選択された組織がありません。左側から選択してください',
  'app.profile.sso.orgSelect.noAvailable': '利用可能な組織がありません',
  'app.profile.sso.orgSelect.authorized': '認証済み',
  'app.profile.sso.orgSelect.cancel': 'キャンセル',
  'app.profile.sso.orgSelect.save': '保存',
  'app.profile.sso.orgSelect.canAuthorize': '認証可能',
  'app.profile.sso.orgSelect.otherAuthorize': 'その他の認証',
  'app.profile.sso.orgSelect.noBenefit': '特典なし',
  'app.profile.sso.orgSelect.saveSuccess': '保存成功',
  'app.profile.sso.list.ssoServiceName': 'SSOサービス名',
  'app.profile.sso.list.ssoType': 'タイプ',
  'app.profile.sso.list.ssoLoginUrl': 'ログインリンク',
  'app.profile.sso.list.authOrgList': '認証済み組織',
  'app.profile.sso.authorized.organizations': '認証済み組織',
  'app.profile.sso.benefit.status': '特典ステータス',

  'app.sso.no.permission.title': 'このページへのアクセス権限がありません',
  'app.sso.no.permission.desc': 'アクセス権限を取得するには、管理者に連絡してください',
  'app.sso.no.permission.logout': 'ログアウト',
};
